import React, { useCallback, useState } from "react";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Divider, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "moment/locale/id";
import ModalDetailShift from "../../components/ModalDetailShift/ModalDetailShift";

interface ICardShiftProps {
    shiftId: number;
    kasir: string;
    mulaiShift: string;
    akhirShift: string;
}

const CardShift = ({
    shiftId,
    kasir,
    mulaiShift,
    akhirShift,
}: ICardShiftProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const [isOpenModalDetailShift, setIsOpenModalDetailShift] = useState(false);

    const openModalDetailShift = useCallback(() => {
        setIsOpenModalDetailShift(true);
    }, []);

    const closeModalDetailShift = useCallback(() => {
        setIsOpenModalDetailShift(false);
    }, []);

    return (
        <Box>
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid item xs={12} container spacing={1} alignItems="center">
                    <Grid item xs={5}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Kasir
                        </Typography>
                        <Typography variant="body1">{kasir}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle2" color="text.secondary">
                            Shift
                        </Typography>
                        <Typography variant="body1">
                            {moment(mulaiShift).format("HH:mm:ss")} -
                            {akhirShift &&
                                `${moment(akhirShift).format("HH:mm:ss")}`}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        xs={2}
                        justifyContent="flex-end"
                        justifyItems="flex-end"
                    >
                        <Button
                            size="small"
                            sx={{ padding: "0.25rem" }}
                            onClick={openModalDetailShift}
                        >
                            <KeyboardArrowRightIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Divider />
            <ModalDetailShift
                fullScreen={fullScreen}
                isOpenModalDetailShift={isOpenModalDetailShift}
                closeModalDetailShift={closeModalDetailShift}
                shiftId={shiftId}
            />
        </Box>
    );
};

export default CardShift;
